<template>
  <div ref="container">
    <!-- Button -->
    <div
      class="fixed top-0 right-0 z-40 pt-2 pr-3 pl-20"
      :class="{ 'text-white cursor-info': delayInfoOpen }"
    >
      <h2
        class="select-none text-mobile lg:text-laptop 2xl:text-copy"
        @click="handleClick"
      >
        {{ delayInfoOpen ? "Close" : "Information" }}
      </h2>
    </div>
    <!-- White mask -->
    <div
      class="pt-3 pb-8 mr-3 fixed top-0 right-0 z-30 mask bg-black"
      :class="{ 'mask-open': infoOpen }"
    />
    <!-- Drawer -->
    <div
      class="overflow-scroll cursor-info fixed top-0 right-0 w-full z-20 h-full bg-black drawer px-3 pt-3 backdrop"
      :class="{ 'drawer-open': infoOpen }"
    >
      <div
        v-if="!!content"
        class="text-white text-mobile lg:text-laptop 2xl:text-copy flex flex-col h-full justify-between"
      >
        <div>
          <hr class="mt-10" />
          <p
            class="mt-6 leading-mobile lg:leading-joni-custom whitespace-pre-line"
            v-text="content.fields.copy"
          />
        </div>

        <div
          class="leading-snug mt-24 mb-3 text-mobile lg:text-laptop 2xl:text-copy"
        >
          <div class="mb-4 flex">
            <a
              class="border rounded-full py-1 hover:bg-white hover:text-black mr-4 h-50 w-50 flex justify-center items-center transition-colors duration-500"
              :href="content.fields.instagramUrl"
              target="_blank"
              >IG</a
            >
            <a
              class="border rounded-full py-1 hover:bg-white hover:text-black mr-4 h-50 w-50 flex justify-center items-center transition-colors duration-500"
              :href="content.fields.linkedInUrl"
              target="_blank"
              >LI</a
            >
          </div>
          <a
            class="border flex justify-center items-center rounded-full h-50 hover:bg-white hover:text-black transition-colors duration-500"
            :href="`mailto:${content.fields.email}`"
            target="_blank"
          >
            Email me
          </a>
          <p class="mt-4 text-xs">{{ content.fields.copywrite }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { INLINES } from "@contentful/rich-text-types";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { mapState } from "vuex";
import { bind } from "@/utils/eventListner";
import store from "@/store";
import { getInfo } from "@/utils/IO";

export default {
  name: "Info",

  data: () => ({
    content: null,
    delayInfoOpen: false,
    documentToHtmlStringOptions: {
      renderNode: {
        [INLINES.HYPERLINK]: (node, next) => {
          return `<a href="${node.data.uri}"${
            node.data.uri.startsWith("https://mydomain.com")
              ? ""
              : ' target="_blank"'
          }>${next(node.content)}</a>`;
        }
      }
    }
  }),

  computed: mapState(["infoOpen"]),

  watch: {
    infoOpen(val) {
      if (val) this.delayInfoOpen = val;
      else setTimeout(() => (this.delayInfoOpen = val), 800);
    }
  },

  async created() {
    this.content = await getInfo();
  },

  mounted() {
    bind(this.$refs.container, "mouseenter", this.handleMouseenter);
    bind(this.$refs.container, "mouseleave", this.handleMouseleave);
  },

  methods: {
    handleMouseenter() {
      store.commit("setMouseInInfo", true);
    },
    handleMouseleave() {
      store.commit("setMouseInInfo", false);
    },
    handleClick() {
      store.commit("setInfoOpen", !this.infoOpen);
    },
    documentToHtmlString: documentToHtmlString
  }
};
</script>

<style scoped>
/* .cursor-info {
  cursor: url("~@/assets/images/dot-white.svg"), auto;
} */

.h-50 {
  height: 50px;
}

.w-50 {
  width: 50px;
}

.drawer,
.mask {
  transform: translateX(100%);
  transition: 1s transform cubic-bezier(0.77, 0, 0.175, 1);

  max-width: 500px;
  will-change: transform;
  /* left: 100%; */
}

.mask {
  width: calc(100% - 1.5rem);
  transform: translateX(calc(100% + 0.75rem));
}

.drawer-open {
  /* left: 0; */
  transform: translateX(0);
}
.mask-open {
  /* left: 0; */
  transform: translateX(0.75rem);
}

@screen lg {
  .drawer-open {
    left: calc(100% - 500px);
  }
  .mask-open {
    left: calc(100% - 500px);
  }
}

@screen 2xl {
  .drawer,
  .mask {
    max-width: 560px;
  }
  .drawer-open {
    left: calc(100% - 560px);
  }
  .mask-open {
    left: calc(100% - 560px);
  }
}

/* 
@media (min-width: 1921px) {
  .drawer,
  .mask {
    max-width: 700px;
  }
  .drawer-open {
    left: calc(100% - 700px);
  }
  .mask-open {
    left: calc(100% - 700px);
  }
} */
</style>
